import React from 'react'
import PropTypes from 'prop-types'

// UTILS
import {
  LocationPopover,
  hasApplyAutocomplete,
} from 'utils/LocationUtil'
import locationUtils from 'utils/common/location'
import I18n from 'i18n/i18n'

// COMPONENTS
import MyLocations from './contact/MyLocations'
import InputPhoneNumber from './InputPhoneNumber'
import MultipleLineAddress from './MultipleLineAddress'
// CONSTANTS
import {
  EMAIL_EXPRESS, OPTIONAL_NOTE
} from 'constants/imageConstants'
import { COUNTRY_ID } from 'constants/dashBoardAnalyticsConstants'
import { GMAPS_BROWSER_KEY, GMAPS_API_VERSION } from 'constants/appConstants'
import { LAZY_SHOW_TOOLTIP_MESSAGE } from 'constants/common/locationConstants'
import { LIMIT_NOTES_CHAR } from 'constants/common/popupConstants'
import StorageKeys from 'constants/storage-keys'
import { isEmpty, isUndefined, size } from 'lodash'
import $ from 'jquery'

class CPOD extends React.Component {
  static disabledAddressAutoFill(address, verifyEnableDocument) {
    return !verifyEnableDocument || (I18n.language.toUpperCase() === COUNTRY_ID) || !address
  }

  static validErrorKeys(invalidKeys, key) {
    if (size(invalidKeys) === 0) {
      return false
    }

    return invalidKeys.includes(key)
  }

  constructor(props) {
    super(props)
    this.state = {
      loadAutoCompleteListener: false,
      isShowNoteField: false,
      maxLength: LIMIT_NOTES_CHAR,
      remainChars: LIMIT_NOTES_CHAR,
    }
    this.location = null
    this.handleCustomerPhoneChange = this.handleCustomerPhoneChange.bind(this)
    this.handleCustomerPhoneBlur = this.handleCustomerPhoneBlur.bind(this)
    this.handleCustomerPhoneFocus = this.handleCustomerPhoneFocus.bind(this)
    this.handleRef = this.handleRef.bind(this)
  }

  componentDidMount() {
    const { enabledAutoCompleted, documentReturn } = this.props
    const { maxLength } = this.state
    if (enabledAutoCompleted) {
      if (window.google && window.google.maps) {
        this.initLoaded()
      } else {
        // Trigger auto call google maps
        window.mapLoaded = () => {
          this.initLoaded()
        }

        if (window.google && window.google.maps) {
          window.mapLoaded()
        } else {
          const s = document.createElement('script')
          s.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_BROWSER_KEY}&v=${GMAPS_API_VERSION}&libraries=places,geometry&callback=mapLoaded&language=${I18n.language}`
          document.head.appendChild(s)
        }
      }
    }
    this.setState({ remainChars: documentReturn.notes ? maxLength - documentReturn.notes.length : maxLength })
  }

  componentDidUpdate() {
    const {
      address,
      handleUpdateAddressComponentForDocumentReturn
    } = this.props
    if ((!this.location && address)
      || (this.location && this.location.formatted_address !== address)
    ) {
      const addressComponents = this.location ? this.location.address_components : null
      if (!addressComponents || addressComponents.length === 0) {
        locationUtils.handleCallGeocodeAPI({ address }, (results) => {
          if (results) {
            const { addressComponent } = locationUtils.getDataResponse(results[0])
            if (this.location) {
              this.location.address_components = addressComponent
            } else {
              this.location = {
                address_components: addressComponent
              }
            }
            this.handleValidateLazyAddress(addressComponent)
            // update address component for document return
            if (handleUpdateAddressComponentForDocumentReturn) {
              handleUpdateAddressComponentForDocumentReturn(addressComponent)
            }
          }
        })
      } else {
        this.handleValidateLazyAddress(addressComponents)
      }
    }
  }

  handleValidateLazyAddress = async (address) => {
    const {
      extraInfos,
      setLocation: currentLocation,
    } = this.props
    const isValid = await locationUtils.validateLazyAddress(
      { address_components: address },
      extraInfos, this.inneraddress_1.closest('.Input'), this.errorMessage, LAZY_SHOW_TOOLTIP_MESSAGE
    )
    if (isValid) {
      this.inneraddress_1.closest('.Input').classList.remove('error')
      const validateLocationNode = document.querySelector(`#validateLocationCODPOD-${currentLocation ? currentLocation.temp_id : ''} .Input`)
      if (validateLocationNode) {
        validateLocationNode.classList.remove('error')
      }
      if(this.errorMessage) this.errorMessage.innerHTML = ''
    }
  }

  initLoaded() {
    const addressName = $(this.inneraddress_1)
    const errorMessage = $(this.errorMessage)

    this.enableAutoComplete()
    addressName.on('keyup', (e) => {
      if (!hasApplyAutocomplete(e.keyCode)) {
        return
      }
      if (!['Enter', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) {
        this.enableAutoComplete()
        this.autocompleteResult()
        if (addressName.val() === '') {
          addressName.closest('.Input').removeClass('error')
          errorMessage.html('')
        }
      }
    })
  }

  enableAutoComplete() {
    const { loadAutoCompleteListener } = this.state
    const {
      area,
      handleAddress,
      handleMappingAddress,
      extraInfos,
      setLocation: currentLocation
    } = this.props
    const restrictCountry = { country: area.country_code }
    if (loadAutoCompleteListener === false) {
      this.updateStatusAutoComplete(true)
      const inputAc = new window.google.maps.places.Autocomplete(this.inneraddress_1, {
        fields: ['name', 'geometry.location', 'place_id', 'formatted_address', 'address_components'],
        componentRestrictions: restrictCountry
      })
      window.google.maps.event.addListener(inputAc, 'place_changed', () => {
        const place = inputAc.getPlace()
        this.location = place
        this.inneraddress_1.closest('.Input').classList.remove('error')
        const validateLocationNode = document.getElementById(`validateLocationCODPOD-${currentLocation.temp_id}`)
        if (validateLocationNode) {
          validateLocationNode.querySelector('.Input').classList.remove('error')
        }
        this.errorMessage.innerHTML = ''
        handleMappingAddress(place.address_components, {
          city: 'administrative_area_level_2',
          state: 'administrative_area_level_1',
          postal_code: 'postal_code',
        })
        handleAddress({
          address: place,
          value: this.inneraddress_1.value,
        }, true)
        // validate lazy address
        locationUtils.validateLazyAddress(place, extraInfos,
          this.inneraddress_1.closest('.Input'), this.errorMessage, LAZY_SHOW_TOOLTIP_MESSAGE)
        this.disableAutoComplete()
      })
    }
  }

  disableAutoComplete() {
    window.google.maps.event.clearInstanceListeners(this.inneraddress_1)
    this.updateStatusAutoComplete(false)
  }

  autocompleteResult() {
    const addressName = $(this.inneraddress_1)
    const errorMessage = $(this.errorMessage)
    setTimeout(() => {
      const getTopPosition = Math.round(addressName.offset().top + 28, 0)
      const isAutoCompleteResult = LocationPopover.checkPositionAutoComplete(getTopPosition, addressName)
      if (isAutoCompleteResult) {
        addressName.closest('.Input').removeClass('error')
        errorMessage.html('')
      } else {
        addressName.closest('.Input').addClass('error')
        errorMessage.html(I18n.t('webapp.new_booking.step_1.location_not_found'))
      }
    }, 250)
  }

  updateStatusAutoComplete(loadAutoCompleteListener) {
    this.setState({ loadAutoCompleteListener })
  }

  handleCustomerPhoneChange(phone) {
    const { handlePhoneChange } = this.props
    handlePhoneChange(phone)
  }

  handleCustomerPhoneBlur(phone) {
    const { handlePhoneChange } = this.props
    handlePhoneChange(phone)
  }

  handleCustomerPhoneFocus(phone) {
    const { handlePhoneChange } = this.props
    handlePhoneChange(phone)
  }

  handleChangeMappingField(value, key) {
    const { handleChangeMappingField } = this.props

    if (!isUndefined(handleChangeMappingField)) {
      handleChangeMappingField([{
        long_name: value,
        short_name: value,
        types: [key],
      }])
    }
  }

  handleSetLocationFromContact(contact) {
    const { handleSelectContact, extraInfos } = this.props
    // validate lazy address
    locationUtils.validateLazyAddress(contact, extraInfos,
      this.inneraddress_1.closest('.Input'), this.errorMessage, LAZY_SHOW_TOOLTIP_MESSAGE)
    this.location = contact
    handleSelectContact(contact)
  }

  handleRef(ref, key) {
    const { onRef } = this.props
    if (ref) {
      onRef(ref, key)
      this[`inner${key}`] = ref
    }
  }

  handleChangePicName(e) {
    const { onchangePicName } = this.props || {}
    const picName = e.target.value
    if (typeof onchangePicName === 'function') onchangePicName(picName)
  }

  handleChangeNotes(e) {
    const { onchangeNotes } = this.props || {}
    const notes = e.target.value
    this.remainingCharacters(notes)
    if (typeof onchangeNotes === 'function') onchangeNotes(notes)
  }

  remainingCharacters(value) {
    const { maxLength } = this.state
    const charCount = value.length
    const remainChars = maxLength - charCount

    this.setState({ remainChars })
  }

  static renderTitle(existedCustomer) {
    return (
      <div className={`flex flex-start ${!existedCustomer ? 'mar10' : ''} pl5 pr5`}>
        <img src={EMAIL_EXPRESS} alt="" />
        <b className="ml10 default-font White-text">
          {I18n.t('webapp.new_booking.step_2.express_mail_document_to')}
        </b>
      </div>
    )
  }

  render() {
    const {
      containerClassName,
      currentCustomer,
      documentReturn,
      extraInfos,
      renderActions,
      isDefaultView,
      handleAddMe,
      contacts,
      personalContacts,
      phoneNumber,
      address,
      stepActions,
      contactActions,
      handleAddress,
      handleAddressKeyDown,
      onRef,
      verifyEnableDocument,
      isScrollPopup,
      popupHeight,
    } = this.props
    const { isShowNoteField, remainChars, maxLength } = this.state
    const { invalidKeys = [] } = documentReturn || {}
    const disabledAddressAutoFill = extraInfos.enable_grey_out_on_document_return || CPOD.disabledAddressAutoFill(address, verifyEnableDocument) ? 'Input-Disabled' : ''
    const isShowText = remainChars <= Math.round(
      maxLength * (extraInfos.remaining_characters_in_note_fields / 100)
    )
    const countryCode = extraInfos.country_code?.toLowerCase()
    return (
      <div className={containerClassName} style={isScrollPopup ? { height: popupHeight } : {}}>
        {/* {Title} */}
        {isDefaultView && CPOD.renderTitle(currentCustomer.id)}

        {currentCustomer.id && verifyEnableDocument ? (
          <div className={`Popover-Item actions ${!isDefaultView ? 'reset pt-imp' : ''}`}>
            <div className="flex-index mr5 ml5">
              <button
                type="button"
                onClick={() => handleAddMe()}
                className="white-text white-border with-icon Button w100"
                disabled={!currentCustomer.id}
              >
                {I18n.t('contacts.labels.add_me')}
              </button>
            </div>
            <MyLocations
              currentCustomer={currentCustomer}
              extraInfos={extraInfos}
              stepActions={stepActions}
              contactActions={contactActions}
              buttonText={I18n.t('contacts.labels.add_from_contact')}
              emptyMessage={I18n.t('booking_details.notify.no_contacts')}
              actionContactText={I18n.t('contacts.labels.set_location')}
              handleSelectContact={({ contact }) => this.handleSetLocationFromContact(contact)}
              contacts={contacts}
              personalContacts={personalContacts}
              className="Popover-Item Selectbox-Contact Selectbox-Contact-Customs active block-imp mr5"
              locationContactID={documentReturn.contactID}
              onRef={(ref) => { this.childMyLocations = ref }}
            />
          </div>
        ) : <div className={isDefaultView ? 'pt15 mar5' : ''} />}

        {!isDefaultView && <div className={currentCustomer.id && verifyEnableDocument ? 'pt15' : ''} />}

        {/* {Form} */}
        <div className={`${(isDefaultView) ? 'mar15' : ''} flex-index`}>
          <div className="mar10">
            {!isDefaultView && (
              <label className="capitalize mar10 ml5 pt5 block White-text default-font">
                {I18n.t('contacts.labels.contact_name')}
              </label>
            )}
            <div className={`Input ${!verifyEnableDocument ? 'Input-Disabled' : ''} ${CPOD.validErrorKeys(invalidKeys, 'recipient_name') ? 'select-error' : ''} pr10 pl10 ml5 mr5`}>
              <input
                className="default-font w100 reset p"
                ref={ref => onRef(ref, 'recipient_name')}
                name="document_returns_recipient_name"
                placeholder={I18n.t('webapp.new_booking.step_2.recipient_name')}
                defaultValue={documentReturn.recipient_name}
                disabled={!verifyEnableDocument}
                tabIndex={1}
                onChange={e => this.handleChangePicName(e)}
              />
            </div>
          </div>
          <div className="mar10 location-number">
            {!isDefaultView && (
              <label className="capitalize mar10 ml5 pt5 block White-text default-font">
                {I18n.t('contacts.labels.contact_phone')}
              </label>
            )}
            <InputPhoneNumber
              isWebApp
              disabled={!verifyEnableDocument}
              customRef={ref => this.handleRef(ref, 'recipient_phone')}
              closestElement={`location-number pr10 pl10 ml5 mr5 ${CPOD.validErrorKeys(invalidKeys, 'recipient_phone') ? 'select-error' : ''}`}
              telInputProps={{ tabIndex: 1 }}
              phoneNumber={phoneNumber}
              countryCode={countryCode}
              fieldId="booking_locations_attributes_cpod_phone"
              phoneField="booking[locations_attributes][cpod_phone]"
              onPhoneChange={this.handleCustomerPhoneChange}
              onPhoneBlur={this.handleCustomerPhoneBlur}
              onPhoneFocus={this.handleCustomerPhoneFocus}
            />
          </div>
          <div className="mar10 relative">
            {!isDefaultView && (
              <label className="capitalize mar10 ml5 pt5 block White-text default-font">
                {I18n.t('contacts.labels.address_detail')}
              </label>
            )}
            <MultipleLineAddress
              onRef={ref => this.handleRef(ref, 'address_1')}
              value={address}
              updateLocationKeyPress={address}
              widthCharacter={9}
              config={{
                classContainer: `Input ${!verifyEnableDocument ? 'Input-Disabled' : ''} ${CPOD.validErrorKeys(invalidKeys, 'address_1') ? 'select-error' : ''} ml5 mr5`,
                classBox: 'flex flex-index',
                classTextarea: 'location-address default-font',
                id: 'booking_locations_attributes_cpod',
                name: 'booking[locations_attributes][cpod]',
                disabled: !verifyEnableDocument,
                placeholder: I18n.t('contacts.labels.address'),
                tabIndex: 1,
              }}
              handleChange={e => handleAddress(e)}
              onKeyDown={e => handleAddressKeyDown(e)}
            />
            <div
              ref={(ref) => { this.errorMessage = ref }}
              className="red ml5 mt5 mar10"
            />
          </div>
          <div className="mar10">
            <div className={`Input ${CPOD.validErrorKeys(invalidKeys, 'city') ? 'select-error' : ''} pr10 pl10 ml5 mr5 ${disabledAddressAutoFill}`}>
              <input
                tabIndex={1}
                className="default-font w100 reset p"
                type="text"
                ref={ref => onRef(ref, 'city')}
                name="document_returns_city"
                placeholder={I18n.t('webapp.new_booking.step_2.city')}
                defaultValue={documentReturn.city}
                onChange={e => this.handleChangeMappingField(e.target.value, 'administrative_area_level_2')}
              />
            </div>
          </div>
          <div className="mar10 flex">
            <div className="flex-three mr5 ml5">
              <div className={`Input ${CPOD.validErrorKeys(invalidKeys, 'state') ? 'select-error' : ''} pr10 pl10 ${disabledAddressAutoFill}`}>
                <input
                  tabIndex={1}
                  className="default-font w100 reset p"
                  type="text"
                  ref={ref => onRef(ref, 'state')}
                  name="document_returns_state"
                  placeholder={I18n.t('webapp.new_booking.step_2.state')}
                  defaultValue={documentReturn.state}
                  onChange={e => this.handleChangeMappingField(e.target.value, 'administrative_area_level_1')}
                />
              </div>
            </div>
            <div className="flex-two mr5 ml5">
              <div className={`Input ${CPOD.validErrorKeys(invalidKeys, 'postal_code') ? 'select-error' : ''} pr10 pl10 ${disabledAddressAutoFill}`}>
                <input
                  tabIndex={1}
                  className="default-font w100 reset p"
                  type="text"
                  ref={ref => onRef(ref, 'postal_code')}
                  name="document_returns_postal_code"
                  placeholder={I18n.t('webapp.new_booking.step_2.postal_code')}
                  defaultValue={documentReturn.postal_code}
                  onChange={e => this.handleChangeMappingField(e.target.value, 'postal_code')}
                />
              </div>
            </div>
          </div>
          {isShowNoteField || !isEmpty(documentReturn.notes) ? (
            <div className="dlvr-note Hide-Border">
              <div className="Countdown-Remaining Default-TextArea-Placeholde w100">
                <div className={`Countdown-Remaining__Input flex ${isShowText ? 'Hide-Border-Bottom Radius-Top-Default' : 'Radius-default'}`}>
                  <textarea
                    autoFocus={isEmpty(documentReturn.notes)}
                    name="document_returns_optional_notes"
                    maxLength={maxLength}
                    className="Resize-None flex flex-index Radius-default pt10 pr10 pb10 pl10 White-bg default-font h80px"
                    placeholder={I18n.t('webapp.new_booking.step_2.optional_notes_to_driver')}
                    ref={ref => onRef(ref, 'notes')}
                    defaultValue={documentReturn.notes}
                    onChange={e => this.handleChangeNotes(e)}
                  />
                </div>
                {isShowText ? (
                  <p className="default-color small-font center Line-bg Radius-Bottom-Default default-color-icon Countdown-Remaining__Info reset m pt5 pl10 pr10 pb5">
                    {`${remainChars} ${I18n.t('webapp.label.characters_remaining')}`}
                  </p>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="flex flex-start pl5 pr5 cur-pointer w-fit-content" onClick={() => this.setState({ isShowNoteField: true })}>
              <img src={OPTIONAL_NOTE} alt="optional_note" />
              <b className="ml10 default-font White-text">
                {I18n.t('webapp.new_booking.step_2.optional_notes_to_driver')}
              </b>
            </div>
          )}
        </div>

        {/* {Actions} */}
        {!isUndefined(renderActions) && size(renderActions().props.children) ? renderActions() : null}
      </div>
    )
  }
}

CPOD.propTypes = {
  area: PropTypes.shape({}),
  address: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  currentCustomer: PropTypes.shape({}),
  containerClassName: PropTypes.string,
  contacts: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  contactActions: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.func,
  ]),
  documentReturn: PropTypes.shape({}),
  extraInfos: PropTypes.shape({}),
  enabledAutoCompleted: PropTypes.bool,
  handleAddMe: PropTypes.func,
  handleAddress: PropTypes.func,
  handleAddressKeyDown: PropTypes.func,
  handleMappingAddress: PropTypes.func,
  handlePhoneChange: PropTypes.func,
  handleSelectContact: PropTypes.func,
  handleChangeMappingField: PropTypes.func,
  isDefaultView: PropTypes.bool,
  personalContacts: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  phoneNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onRef: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.func,
  ]),
  renderActions: PropTypes.func,
  stepActions: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.func,
  ]),
  verifyEnableDocument: PropTypes.bool,
  setLocation: PropTypes.shape({}),
  handleUpdateAddressComponentForDocumentReturn: PropTypes.shape({}),
  isScrollPopup: PropTypes.bool,
  popupHeight: PropTypes.number,
}

CPOD.defaultProps = {
  area: {},
  address: undefined,
  currentCustomer: {},
  containerClassName: '',
  contacts: {},
  contactActions: undefined,
  documentReturn: {
    recipient_name: '',
    recipient_phone: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    postal_code: '',
    latitude: null,
    longitude: null,
    notes: '',

    // local keys
    is_show: false,
    is_required: false,
    invalidKeys: [],
  },
  extraInfos: {},
  enabledAutoCompleted: false,
  handleAddMe: undefined,
  handleAddress: undefined,
  handleAddressKeyDown: undefined,
  handleMappingAddress: undefined,
  handlePhoneChange: undefined,
  handleSelectContact: undefined,
  handleChangeMappingField: undefined,
  isDefaultView: false,
  personalContacts: {},
  phoneNumber: undefined,
  onRef: undefined,
  renderActions: undefined,
  stepActions: undefined,
  verifyEnableDocument: false,
  setLocation: {},
  handleUpdateAddressComponentForDocumentReturn: null,
  isScrollPopup: false,
  popupHeight: 0,
}

export default CPOD
